import { render, staticRenderFns } from "./LengthsList.vue?vue&type=template&id=886f4278&scoped=true"
import script from "./LengthsList.vue?vue&type=script&lang=js"
export * from "./LengthsList.vue?vue&type=script&lang=js"
import style0 from "./LengthsList.vue?vue&type=style&index=0&id=886f4278&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "886f4278",
  null
  
)

export default component.exports